// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v6.33.3
// source: position.proto

/* eslint-disable */
import * as _m0 from "protobufjs/minimal";
import { Security } from "./candle-data-depot-common";
import { Product, productFromJSON, productToJSON } from "./order";
import Long from "long";

export const protobufPackage = "com.tick2trade.api.position";

export interface PositionRequest {
  tradingAccountId: string;
}

export interface PositionResponse {
  position: Position[];
}

export interface Position {
  basketId: string;
  product: Product;
  security: Security | undefined;
  strategyGroup: string;
  date: number;
  overnightPosition: number;
  overnightPositionValue: number;
  closePosition: number;
  closePositionValue: number;
  dayBuyQuantity: number;
  daySellQuantity: number;
  dayBuyValue: number;
  daySellValue: number;
  realisedQuantity: number;
  realisedBuyValue: number;
  realisedSellValue: number;
  realisedProfit: number;
  status: Position_Status;
  adjusted: boolean;
}

export enum Position_Status {
  STATUS_UNKNOWN = 0,
  ACTIVE = 1,
  CLOSED = 2,
  SETTLED = 3,
  UNRECOGNIZED = -1,
}

export function position_StatusFromJSON(object: any): Position_Status {
  switch (object) {
    case 0:
    case "STATUS_UNKNOWN":
      return Position_Status.STATUS_UNKNOWN;
    case 1:
    case "ACTIVE":
      return Position_Status.ACTIVE;
    case 2:
    case "CLOSED":
      return Position_Status.CLOSED;
    case 3:
    case "SETTLED":
      return Position_Status.SETTLED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Position_Status.UNRECOGNIZED;
  }
}

export function position_StatusToJSON(object: Position_Status): string {
  switch (object) {
    case Position_Status.STATUS_UNKNOWN:
      return "STATUS_UNKNOWN";
    case Position_Status.ACTIVE:
      return "ACTIVE";
    case Position_Status.CLOSED:
      return "CLOSED";
    case Position_Status.SETTLED:
      return "SETTLED";
    case Position_Status.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface ShiftPositionRequest {
  tradingAccountId: string;
  position: Position | undefined;
  targetBasketId: string;
  quantityToShift: number;
}

export interface ShiftPositionResponse {
  success: boolean;
  message: string;
  updatedPositions: Position[];
}

function createBasePositionRequest(): PositionRequest {
  return { tradingAccountId: "" };
}

export const PositionRequest = {
  encode(message: PositionRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.tradingAccountId !== "") {
      writer.uint32(10).string(message.tradingAccountId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PositionRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePositionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.tradingAccountId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PositionRequest {
    return { tradingAccountId: isSet(object.tradingAccountId) ? globalThis.String(object.tradingAccountId) : "" };
  },

  toJSON(message: PositionRequest): unknown {
    const obj: any = {};
    if (message.tradingAccountId !== "") {
      obj.tradingAccountId = message.tradingAccountId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PositionRequest>, I>>(base?: I): PositionRequest {
    return PositionRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PositionRequest>, I>>(object: I): PositionRequest {
    const message = createBasePositionRequest();
    message.tradingAccountId = object.tradingAccountId ?? "";
    return message;
  },
};

function createBasePositionResponse(): PositionResponse {
  return { position: [] };
}

export const PositionResponse = {
  encode(message: PositionResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.position) {
      Position.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PositionResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePositionResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 18) {
            break;
          }

          message.position.push(Position.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PositionResponse {
    return {
      position: globalThis.Array.isArray(object?.position) ? object.position.map((e: any) => Position.fromJSON(e)) : [],
    };
  },

  toJSON(message: PositionResponse): unknown {
    const obj: any = {};
    if (message.position?.length) {
      obj.position = message.position.map((e) => Position.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PositionResponse>, I>>(base?: I): PositionResponse {
    return PositionResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PositionResponse>, I>>(object: I): PositionResponse {
    const message = createBasePositionResponse();
    message.position = object.position?.map((e) => Position.fromPartial(e)) || [];
    return message;
  },
};

function createBasePosition(): Position {
  return {
    basketId: "",
    product: 0,
    security: undefined,
    strategyGroup: "",
    date: 0,
    overnightPosition: 0,
    overnightPositionValue: 0,
    closePosition: 0,
    closePositionValue: 0,
    dayBuyQuantity: 0,
    daySellQuantity: 0,
    dayBuyValue: 0,
    daySellValue: 0,
    realisedQuantity: 0,
    realisedBuyValue: 0,
    realisedSellValue: 0,
    realisedProfit: 0,
    status: 0,
    adjusted: false,
  };
}

export const Position = {
  encode(message: Position, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.basketId !== "") {
      writer.uint32(10).string(message.basketId);
    }
    if (message.product !== 0) {
      writer.uint32(16).int32(message.product);
    }
    if (message.security !== undefined) {
      Security.encode(message.security, writer.uint32(26).fork()).ldelim();
    }
    if (message.strategyGroup !== "") {
      writer.uint32(34).string(message.strategyGroup);
    }
    if (message.date !== 0) {
      writer.uint32(40).int64(message.date);
    }
    if (message.overnightPosition !== 0) {
      writer.uint32(48).int32(message.overnightPosition);
    }
    if (message.overnightPositionValue !== 0) {
      writer.uint32(57).double(message.overnightPositionValue);
    }
    if (message.closePosition !== 0) {
      writer.uint32(64).int32(message.closePosition);
    }
    if (message.closePositionValue !== 0) {
      writer.uint32(73).double(message.closePositionValue);
    }
    if (message.dayBuyQuantity !== 0) {
      writer.uint32(80).int32(message.dayBuyQuantity);
    }
    if (message.daySellQuantity !== 0) {
      writer.uint32(88).int32(message.daySellQuantity);
    }
    if (message.dayBuyValue !== 0) {
      writer.uint32(97).double(message.dayBuyValue);
    }
    if (message.daySellValue !== 0) {
      writer.uint32(105).double(message.daySellValue);
    }
    if (message.realisedQuantity !== 0) {
      writer.uint32(120).int32(message.realisedQuantity);
    }
    if (message.realisedBuyValue !== 0) {
      writer.uint32(129).double(message.realisedBuyValue);
    }
    if (message.realisedSellValue !== 0) {
      writer.uint32(137).double(message.realisedSellValue);
    }
    if (message.realisedProfit !== 0) {
      writer.uint32(113).double(message.realisedProfit);
    }
    if (message.status !== 0) {
      writer.uint32(240).int32(message.status);
    }
    if (message.adjusted !== false) {
      writer.uint32(248).bool(message.adjusted);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Position {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePosition();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.basketId = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.product = reader.int32() as any;
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.security = Security.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.strategyGroup = reader.string();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.date = longToNumber(reader.int64() as Long);
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.overnightPosition = reader.int32();
          continue;
        case 7:
          if (tag !== 57) {
            break;
          }

          message.overnightPositionValue = reader.double();
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.closePosition = reader.int32();
          continue;
        case 9:
          if (tag !== 73) {
            break;
          }

          message.closePositionValue = reader.double();
          continue;
        case 10:
          if (tag !== 80) {
            break;
          }

          message.dayBuyQuantity = reader.int32();
          continue;
        case 11:
          if (tag !== 88) {
            break;
          }

          message.daySellQuantity = reader.int32();
          continue;
        case 12:
          if (tag !== 97) {
            break;
          }

          message.dayBuyValue = reader.double();
          continue;
        case 13:
          if (tag !== 105) {
            break;
          }

          message.daySellValue = reader.double();
          continue;
        case 15:
          if (tag !== 120) {
            break;
          }

          message.realisedQuantity = reader.int32();
          continue;
        case 16:
          if (tag !== 129) {
            break;
          }

          message.realisedBuyValue = reader.double();
          continue;
        case 17:
          if (tag !== 137) {
            break;
          }

          message.realisedSellValue = reader.double();
          continue;
        case 14:
          if (tag !== 113) {
            break;
          }

          message.realisedProfit = reader.double();
          continue;
        case 30:
          if (tag !== 240) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        case 31:
          if (tag !== 248) {
            break;
          }

          message.adjusted = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Position {
    return {
      basketId: isSet(object.basketId) ? globalThis.String(object.basketId) : "",
      product: isSet(object.product) ? productFromJSON(object.product) : 0,
      security: isSet(object.security) ? Security.fromJSON(object.security) : undefined,
      strategyGroup: isSet(object.strategyGroup) ? globalThis.String(object.strategyGroup) : "",
      date: isSet(object.date) ? globalThis.Number(object.date) : 0,
      overnightPosition: isSet(object.overnightPosition) ? globalThis.Number(object.overnightPosition) : 0,
      overnightPositionValue: isSet(object.overnightPositionValue)
        ? globalThis.Number(object.overnightPositionValue)
        : 0,
      closePosition: isSet(object.closePosition) ? globalThis.Number(object.closePosition) : 0,
      closePositionValue: isSet(object.closePositionValue) ? globalThis.Number(object.closePositionValue) : 0,
      dayBuyQuantity: isSet(object.dayBuyQuantity) ? globalThis.Number(object.dayBuyQuantity) : 0,
      daySellQuantity: isSet(object.daySellQuantity) ? globalThis.Number(object.daySellQuantity) : 0,
      dayBuyValue: isSet(object.dayBuyValue) ? globalThis.Number(object.dayBuyValue) : 0,
      daySellValue: isSet(object.daySellValue) ? globalThis.Number(object.daySellValue) : 0,
      realisedQuantity: isSet(object.realisedQuantity) ? globalThis.Number(object.realisedQuantity) : 0,
      realisedBuyValue: isSet(object.realisedBuyValue) ? globalThis.Number(object.realisedBuyValue) : 0,
      realisedSellValue: isSet(object.realisedSellValue) ? globalThis.Number(object.realisedSellValue) : 0,
      realisedProfit: isSet(object.realisedProfit) ? globalThis.Number(object.realisedProfit) : 0,
      status: isSet(object.status) ? position_StatusFromJSON(object.status) : 0,
      adjusted: isSet(object.adjusted) ? globalThis.Boolean(object.adjusted) : false,
    };
  },

  toJSON(message: Position): unknown {
    const obj: any = {};
    if (message.basketId !== "") {
      obj.basketId = message.basketId;
    }
    if (message.product !== 0) {
      obj.product = productToJSON(message.product);
    }
    if (message.security !== undefined) {
      obj.security = Security.toJSON(message.security);
    }
    if (message.strategyGroup !== "") {
      obj.strategyGroup = message.strategyGroup;
    }
    if (message.date !== 0) {
      obj.date = Math.round(message.date);
    }
    if (message.overnightPosition !== 0) {
      obj.overnightPosition = Math.round(message.overnightPosition);
    }
    if (message.overnightPositionValue !== 0) {
      obj.overnightPositionValue = message.overnightPositionValue;
    }
    if (message.closePosition !== 0) {
      obj.closePosition = Math.round(message.closePosition);
    }
    if (message.closePositionValue !== 0) {
      obj.closePositionValue = message.closePositionValue;
    }
    if (message.dayBuyQuantity !== 0) {
      obj.dayBuyQuantity = Math.round(message.dayBuyQuantity);
    }
    if (message.daySellQuantity !== 0) {
      obj.daySellQuantity = Math.round(message.daySellQuantity);
    }
    if (message.dayBuyValue !== 0) {
      obj.dayBuyValue = message.dayBuyValue;
    }
    if (message.daySellValue !== 0) {
      obj.daySellValue = message.daySellValue;
    }
    if (message.realisedQuantity !== 0) {
      obj.realisedQuantity = Math.round(message.realisedQuantity);
    }
    if (message.realisedBuyValue !== 0) {
      obj.realisedBuyValue = message.realisedBuyValue;
    }
    if (message.realisedSellValue !== 0) {
      obj.realisedSellValue = message.realisedSellValue;
    }
    if (message.realisedProfit !== 0) {
      obj.realisedProfit = message.realisedProfit;
    }
    if (message.status !== 0) {
      obj.status = position_StatusToJSON(message.status);
    }
    if (message.adjusted !== false) {
      obj.adjusted = message.adjusted;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Position>, I>>(base?: I): Position {
    return Position.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Position>, I>>(object: I): Position {
    const message = createBasePosition();
    message.basketId = object.basketId ?? "";
    message.product = object.product ?? 0;
    message.security = (object.security !== undefined && object.security !== null)
      ? Security.fromPartial(object.security)
      : undefined;
    message.strategyGroup = object.strategyGroup ?? "";
    message.date = object.date ?? 0;
    message.overnightPosition = object.overnightPosition ?? 0;
    message.overnightPositionValue = object.overnightPositionValue ?? 0;
    message.closePosition = object.closePosition ?? 0;
    message.closePositionValue = object.closePositionValue ?? 0;
    message.dayBuyQuantity = object.dayBuyQuantity ?? 0;
    message.daySellQuantity = object.daySellQuantity ?? 0;
    message.dayBuyValue = object.dayBuyValue ?? 0;
    message.daySellValue = object.daySellValue ?? 0;
    message.realisedQuantity = object.realisedQuantity ?? 0;
    message.realisedBuyValue = object.realisedBuyValue ?? 0;
    message.realisedSellValue = object.realisedSellValue ?? 0;
    message.realisedProfit = object.realisedProfit ?? 0;
    message.status = object.status ?? 0;
    message.adjusted = object.adjusted ?? false;
    return message;
  },
};

function createBaseShiftPositionRequest(): ShiftPositionRequest {
  return { tradingAccountId: "", position: undefined, targetBasketId: "", quantityToShift: 0 };
}

export const ShiftPositionRequest = {
  encode(message: ShiftPositionRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.tradingAccountId !== "") {
      writer.uint32(10).string(message.tradingAccountId);
    }
    if (message.position !== undefined) {
      Position.encode(message.position, writer.uint32(18).fork()).ldelim();
    }
    if (message.targetBasketId !== "") {
      writer.uint32(26).string(message.targetBasketId);
    }
    if (message.quantityToShift !== 0) {
      writer.uint32(32).int32(message.quantityToShift);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ShiftPositionRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseShiftPositionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.tradingAccountId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.position = Position.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.targetBasketId = reader.string();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.quantityToShift = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ShiftPositionRequest {
    return {
      tradingAccountId: isSet(object.tradingAccountId) ? globalThis.String(object.tradingAccountId) : "",
      position: isSet(object.position) ? Position.fromJSON(object.position) : undefined,
      targetBasketId: isSet(object.targetBasketId) ? globalThis.String(object.targetBasketId) : "",
      quantityToShift: isSet(object.quantityToShift) ? globalThis.Number(object.quantityToShift) : 0,
    };
  },

  toJSON(message: ShiftPositionRequest): unknown {
    const obj: any = {};
    if (message.tradingAccountId !== "") {
      obj.tradingAccountId = message.tradingAccountId;
    }
    if (message.position !== undefined) {
      obj.position = Position.toJSON(message.position);
    }
    if (message.targetBasketId !== "") {
      obj.targetBasketId = message.targetBasketId;
    }
    if (message.quantityToShift !== 0) {
      obj.quantityToShift = Math.round(message.quantityToShift);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ShiftPositionRequest>, I>>(base?: I): ShiftPositionRequest {
    return ShiftPositionRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ShiftPositionRequest>, I>>(object: I): ShiftPositionRequest {
    const message = createBaseShiftPositionRequest();
    message.tradingAccountId = object.tradingAccountId ?? "";
    message.position = (object.position !== undefined && object.position !== null)
      ? Position.fromPartial(object.position)
      : undefined;
    message.targetBasketId = object.targetBasketId ?? "";
    message.quantityToShift = object.quantityToShift ?? 0;
    return message;
  },
};

function createBaseShiftPositionResponse(): ShiftPositionResponse {
  return { success: false, message: "", updatedPositions: [] };
}

export const ShiftPositionResponse = {
  encode(message: ShiftPositionResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success);
    }
    if (message.message !== "") {
      writer.uint32(18).string(message.message);
    }
    for (const v of message.updatedPositions) {
      Position.encode(v!, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ShiftPositionResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseShiftPositionResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.success = reader.bool();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.message = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.updatedPositions.push(Position.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ShiftPositionResponse {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      message: isSet(object.message) ? globalThis.String(object.message) : "",
      updatedPositions: globalThis.Array.isArray(object?.updatedPositions)
        ? object.updatedPositions.map((e: any) => Position.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ShiftPositionResponse): unknown {
    const obj: any = {};
    if (message.success !== false) {
      obj.success = message.success;
    }
    if (message.message !== "") {
      obj.message = message.message;
    }
    if (message.updatedPositions?.length) {
      obj.updatedPositions = message.updatedPositions.map((e) => Position.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ShiftPositionResponse>, I>>(base?: I): ShiftPositionResponse {
    return ShiftPositionResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ShiftPositionResponse>, I>>(object: I): ShiftPositionResponse {
    const message = createBaseShiftPositionResponse();
    message.success = object.success ?? false;
    message.message = object.message ?? "";
    message.updatedPositions = object.updatedPositions?.map((e) => Position.fromPartial(e)) || [];
    return message;
  },
};

export interface PositionService {
  GetPositions(request: PositionRequest): Promise<PositionResponse>;
  GetPositionsAdmin(request: PositionRequest): Promise<PositionResponse>;
  ShiftPositions(request: ShiftPositionRequest): Promise<ShiftPositionResponse>;
}

export const PositionServiceServiceName = "com.tick2trade.api.position.PositionService";
export class PositionServiceClientImpl implements PositionService {
  private readonly rpc: Rpc;
  private readonly service: string;
  constructor(rpc: Rpc, opts?: { service?: string }) {
    this.service = opts?.service || PositionServiceServiceName;
    this.rpc = rpc;
    this.GetPositions = this.GetPositions.bind(this);
    this.GetPositionsAdmin = this.GetPositionsAdmin.bind(this);
    this.ShiftPositions = this.ShiftPositions.bind(this);
  }
  GetPositions(request: PositionRequest): Promise<PositionResponse> {
    const data = PositionRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetPositions", data);
    return promise.then((data) => PositionResponse.decode(_m0.Reader.create(data)));
  }

  GetPositionsAdmin(request: PositionRequest): Promise<PositionResponse> {
    const data = PositionRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetPositionsAdmin", data);
    return promise.then((data) => PositionResponse.decode(_m0.Reader.create(data)));
  }

  ShiftPositions(request: ShiftPositionRequest): Promise<ShiftPositionResponse> {
    const data = ShiftPositionRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "ShiftPositions", data);
    return promise.then((data) => ShiftPositionResponse.decode(_m0.Reader.create(data)));
  }
}

interface Rpc {
  request(service: string, method: string, data: Uint8Array): Promise<Uint8Array>;
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (long.lt(globalThis.Number.MIN_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
